import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { downloadPreviewData } from "../../waitlist/services/waitlist-service";

export default function AddressPreview(props) {
  const { isOpen, toggle, address } = props;
  const [imgObj, setImgObj] = useState({});

  const checkIfPdf = (filename) => {
    let tempFilenameArr= filename.split('.');
    return tempFilenameArr[tempFilenameArr.length - 1] === 'pdf';
  }

  useEffect(async () => {
    let docTypes = ['pan', 'poi', 'address', 'address_1']
    for (let type of docTypes) {
      let doc = address.find(e => e.type === type);
      if (doc) {
        let file = await downloadPreviewData(doc.data)
        .then((res, err) => {
          if (!res || res.err) {
            toast.error(
              err.msg || "Not able to fetch data. Please try again"
            );
            return;
          }
          return URL.createObjectURL(res);
        });
        let imgTempObj =  imgObj;
        imgTempObj[type] = {
          data: file,
          filename: doc.data
        }
        setImgObj({...imgTempObj});
      }
    }
  }, [address]);
  
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader isOpen={isOpen} toggle={toggle}></ModalHeader>
      <ModalBody>        
        <div className="d-flex flex-column p-2">
        {Object.keys(imgObj).map(key => (
          checkIfPdf(imgObj[key].filename) ?
          <>
            <p className="font-weight-semi-bold mb-1 mt-3">
              {key === 'pan' ? "PAN" : 
                key === 'address' ? "Address Front" : "Address Back"}
            </p>
            <embed 
              id='iframeData'
              src={imgObj[key].data}
              type="application/pdf"
              height="600px"
              width="100%"
            /> 
          </> :
          <>
            <p className="font-weight-semi-bold mb-1 mt-3">
              {key === 'pan' ? "PAN" : 
                key === 'address' ? "Address Front" : "Address Back"}
            </p>
            <img className="img img-fluid mt-3" src={imgObj[key].data} alt="img"/>
          </>))}
        </div>
      </ModalBody>
      <ToastContainer />
    </Modal>
  );
}